import type { SidePanel } from '../types';

export const TransactionDetail: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./TransactionDetailPanel.vue')),
};
